/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-undef */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Avatar_16,
  Avatar_02,
  Avatar_05,
  Avatar_09,
  Avatar_10,
} from "../../../Routes/ImagePath/index";

import { Link } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";

import React, { useState, useEffect } from "react";

import AuthUser from "../../AuthUser";

import { toast, ToastContainer } from "react-toastify";

import Spinner from "../../Spinner";

import Swal from "sweetalert2";

import { Alert } from "react-bootstrap";

const CursoEditModal = ({ onSubmissionSuccess, curso }) => {
  const { t } = useTranslation();

  // eslint-disable-next-line no-unused-vars
  const {
    http,
    url_root,
    user,
    user_permissoes,
    verificarPermissao,
    getMissao,
  } = AuthUser();

  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  // Estados dos inputs
  const [short, setShort] = useState("");
  const [designation, setDesignation] = useState("");
  const [description, setDescription] = useState("");
  const [level, setLevel] = useState("4");
  const [duration, setDuration] = useState(1);
  const [expiration, setExpiration] = useState("1");
  const [MIREMPET, setMIREMPET] = useState("0");
  const [expiration_period, setExpirationPeriod] = useState("2");
  const [expire, setExpire] = useState("1");

  const [imagem, setSelectedFile] = useState(null);
  const [imagemPreview, setimagemPreview] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setShort("");
        setDesignation("");
        setDescription("");
        setLevel("1");
        setDuration(1);
        setExpiration("1");
        setExpirationPeriod("2");
        setExpire("1");

        setSelectedFile(null);

        setShort(curso?.sigla);
        setDesignation(curso?.designacao);
        setDescription(curso?.descricao);
        setLevel(curso?.nivel);
        setDuration(curso?.duracao);
        setExpiration(curso?.expiracao);
        setExpirationPeriod(curso?.expira_unidade);
        setExpire(curso?.expira);

        setimagemPreview(url_root + "/storage/cursos/" + curso?.imagem);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [curso]);

  const triggerCloseButtonClick = (buttonId) => {
    const closeButton = document.getElementById(buttonId);
    if (closeButton) {
      closeButton.dispatchEvent(new Event("click"));
    }
  };

  const handleSubmit = async () => {
    if (!designation.trim()) return toast.error("Designação é obrigatória.");
    if (!short.trim()) return toast.error("Sigla é obrigatória.");

    try {
      setLoading(true);

      const formData = new FormData();
      if (imagem) {
        formData.append("imagem", imagem);
      }

      formData.append("id", curso?.id);
      formData.append("sigla", short);
      formData.append("designacao", designation);
      formData.append("descricao", description);
      formData.append("nivel", level);
      formData.append("duracao", String(duration));
      formData.append("expiracao", expiration);
      formData.append("MIREMPET", MIREMPET);
      formData.append("expira_unidade", expiration_period);
      formData.append("expira", expire);

      const res = await http.post("/update-curso", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      //toast.success("Curso atualizado com sucesso.");

      // Show a success toast
      toast.success(res.data.message, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        onClose: () => {
          triggerCloseButtonClick("closeButton30");

          console.log("to send : ");
          onSubmissionSuccess(res?.data?.cursos);
        },
      });
    } catch (error) {
      console.error(error);
      toast.error("Failed to update training ( here ).");
    } finally {
      setLoading(false);
    }
  };

  /* Imagem do logotipo */

  const handleFileChange = (e) => {
    const newFile = e.target.files[0];

    // Lógica para processar a imagem, se necessário
    setSelectedFile(newFile);

    // Atualize diretamente o src da imagem
    const newFileURL = URL.createObjectURL(newFile);
    //document.getElementById('imagem').src = newFileURL;

    setimagemPreview(newFileURL);

    console.log("New image url 1:");
    console.log(newFileURL);
    // Restante do código
  };

  return (
    <>
      {/* Add Task Modal */}
      <div
        id="edit_curso_modal"
        className="modal custom-modal fade modal-lg"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{t("Editar certificação")}</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                id="closeButton30"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              {/* OPEN ROW */}
              <div className="row">
                <div className="col-xl-12 mb-3">
                  {loading && (
                    <div className="alert alert-primary text-center my-3">
                      <i className="fa fa-spinner fa-spin me-2"></i>{" "}
                      Carregando...
                    </div>
                  )}
                </div>

                <div className="container-fluid">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="input-block form-focus focused mb-5">
                        <div className="profile-img-wrap edit-img">
                          <img className="inline-block" src={imagemPreview} />
                          <div className="fileupload btn">
                            <span className="btn-text">editar</span>
                            <input
                              className="upload"
                              type="file"
                              onChange={handleFileChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-12 mb-3 mt-5">
                      <label className="form-label">
                        Designação <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={designation}
                        onChange={(e) => setDesignation(e.target.value)}
                        placeholder="Ex: Confined Space Entry"
                      />
                    </div>

                    <div className="col-xl-4 mb-3">
                      <label className="form-label">
                        Sigla <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={short}
                        onChange={(e) => setShort(e.target.value)}
                        placeholder="Ex: CSE"
                      />
                    </div>

                    <div className="col-xl-4 mb-3">
                      <label className="form-label">
                        Nível <span className="text-danger">*</span>
                      </label>
                      <select
                        className="default-select form-control"
                        value={level}
                        onChange={(e) => setLevel(e.target.value)}
                      >
                        <option value="1">Básico</option>
                        <option value="2">Intermédio</option>
                        <option value="3">Avançado</option>
                        <option value="4">Padrão</option>
                      </select>
                    </div>

                    <div className="col-xl-4 mb-3">
                      <label className="form-label">
                        Duração (em Horas){" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        value={duration}
                        onChange={(e) => setDuration(Number(e.target.value))}
                        placeholder="Ex: 80"
                      />
                    </div>

                    <div className="col-xl-4 mb-3">
                      <label className="form-label">
                        Tem tempo de validade ?{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <select
                        className="default-select form-control"
                        onChange={(e) => setExpire(e.target.value)}
                        value={expire}
                      >
                        <option data-display={-1}>Select</option>
                        <option value={1}>Sim</option>
                        <option value={2}>Não</option>
                      </select>
                    </div>

                    <div className="col-xl-4 mb-3">
                      <label className="form-label">
                        Periodo de validade{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <select
                        className="default-select form-control"
                        onChange={(e) => setExpirationPeriod(e.target.value)}
                        value={expiration_period}
                      >
                        <option data-display={-1}>Select</option>
                        <option value={1}>Mês</option>
                        <option value={2}>Ano</option>
                      </select>
                    </div>

                    <div className="col-xl-4 mb-3">
                      <label className="form-label">
                        Validade <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        value={expiration}
                        onChange={(e) => setExpiration(e.target.value)}
                        placeholder="Ex: 2"
                      />
                    </div>

                    <div className="col-xl-12 mb-3">
                      <label className="form-label">
                        Descrição ( opcional )
                      </label>
                      <textarea
                        rows={4}
                        className="form-control"
                        value={description}
                        onChange={(e) => setDescription(String(e.target.value))}
                      />
                    </div>
                  </div>

                  <div>
                    {loading ? (
                      <button type="button" className="btn btn-primary me-1">
                        <i className="fa fa-spinner fa-spin"></i> Enviando...
                      </button>
                    ) : (
                      <button
                        onClick={handleSubmit}
                        type="button"
                        className="btn btn-primary me-1"
                      >
                        Atualizar
                      </button>
                    )}
                    <Link
                      href={"#"}
                      onClick={() => setShowModal(false)}
                      className="btn btn-danger light ms-1"
                    >
                      Cancelar
                    </Link>
                  </div>
                </div>

                {/* CLOSE ROW */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Task Modal */}

      <ToastContainer />
    </>
  );
};

export default CursoEditModal;
